import { render, staticRenderFns } from "./DashboardCountBox.vue?vue&type=template&id=2c825a34&scoped=true"
import script from "./DashboardCountBox.vue?vue&type=script&lang=js"
export * from "./DashboardCountBox.vue?vue&type=script&lang=js"
import style0 from "./DashboardCountBox.vue?vue&type=style&index=0&id=2c825a34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c825a34",
  null
  
)

export default component.exports